import typograf from 'utils/typograf';

export default function beautifyText(text) {
  return typograf
    .execute(text)

    // неразрывный пробел - на обычный
    .replace(/ /g, ' '); // eslint-disable-line no-irregular-whitespace;
}
